
export default {
  props: {
    store: {type: Object, required: true},
  },
  emits: ['update'],
  computed: {
    my_store() {
      return this.store
    },
    skills() {
      return this.my_store.skills
    },
    sources() {
      return this.my_store.sources
    },
  },
  methods: {
    toggle(key, command) {
      const values = this[key].includes(command)
        ? this[key].filter(value => value !== command)
        : [...this[key], command]

      this.my_store[key] = values
      this.$emit('update')
    },
  },
}
